import React, { ChangeEvent, ReactElement, useState } from 'react';

import './range-slider.scss';

export interface SliderProps {
    min: number;
    max: number;
    step?: number;
    defaultValue: number;
    primaryColor?: string;
    secondaryColor?: string;
    onChange: (value: number) => void;
}

const RangeSlider: React.FC<SliderProps> = ({
    min,
    max,
    step,
    defaultValue,
    primaryColor = '#0134a5',
    secondaryColor = '#e4d5aa',
    onChange
}): ReactElement => {
    const [value, setValue] = useState(defaultValue);

    React.useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);

    const onValueChange = (event: ChangeEvent<HTMLInputElement>): void => {
        onChange(Number(event.currentTarget.value));
        setValue(Number(event.currentTarget.value));
    };

    return (
        <div className="slider-box">
            <input
                className="range-slider"
                type="range"
                aria-label="alert-range"
                min={min}
                max={max}
                step={step}
                value={value}
                onChange={onValueChange}
                style={{ backgroundImage: `linear-gradient(90deg, ${primaryColor} ${value / max * 100}%, ${secondaryColor} ${value / max * 100}%)` }}
            />
        </div>
    );
};

export default RangeSlider;
